









import Vue, { PropType } from "vue";
import { Data, Methods, Computed, Props } from "./types";
import { RECRUITMENT_NUMBER_OPTIONS } from "../../../../../constants/onboarding";
import PopoverSelectBox from "@/components/Atoms/Forms/PopoverSelectBox/index.vue";

export default Vue.extend<Data, Methods, Computed, Props>({
  name: "RecruitmentNumberForm",
  components: {
    PopoverSelectBox
  },
  props: {
    recruitmentNumber: {
      type: Number as PropType<Props["recruitmentNumber"]>,
      required: true
    }
  },
  data() {
    return {
      recruitmentNumberOptions: RECRUITMENT_NUMBER_OPTIONS
    };
  },
  computed: {
    modeledRecruitmentNumber: {
      get() {
        return this.recruitmentNumber;
      },
      set(val) {
        this.$emit("change", val);
      }
    }
  }
});
